const comments = [
  {
    id: 1,
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20young%20Asian%20person%20with%20warm%20friendly%20expression%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20natural%20look&width=120&height=120&seq=avatar-1-2026&orientation=squarish',
    rating: 5,
    text: '一直在用番茄视频追剧，画质真的没话说，1080P高清不缓冲，香蕉视频和红桃视频的资源也特别全，推荐给身边所有喜欢看电影的朋友了！',
    time: '3天前',
  },
  {
    id: 2,
    name: '电影发烧友小李',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20Asian%20person%20wearing%20glasses%20with%20warm%20smile%2C%20studio%20lighting%2C%20clean%20neutral%20background%2C%20natural%20expression&width=120&height=120&seq=avatar-2-2026&orientation=squarish',
    rating: 5,
    text: '蜜桃视频的综艺更新速度太快了！每周追的综艺基本第二天就能看到高清版，而且播放特别流畅，从来没卡过，体验超棒。',
    time: '5天前',
  },
  {
    id: 3,
    name: '夜猫子剧迷',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20young%20Asian%20woman%20with%20gentle%20smile%2C%20soft%20studio%20lighting%2C%20clean%20background%2C%20casual%20natural%20look&width=120&height=120&seq=avatar-3-2026&orientation=squarish',
    rating: 4,
    text: '晚上躺床上用手机看番茄视频，画质调到高清模式也很清晰。91视频的经典老片资源也很丰富，怀旧党狂喜！界面简洁好操作。',
    time: '1周前',
  },
  {
    id: 4,
    name: '全家追剧代表',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20Asian%20person%20with%20bright%20friendly%20smile%2C%20warm%20studio%20portrait%2C%20clean%20neutral%20background%2C%20natural%20lighting&width=120&height=120&seq=avatar-4-2026&orientation=squarish',
    rating: 5,
    text: '家里老小都用番茄视频，分类很清晰，老人找老电影、孩子看动画片都很方便。高清不缓冲是最大的亮点，电信移动都能流畅播。',
    time: '2周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">用户口碑</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">听听追剧达人们怎么说番茄视频</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {comments.map((comment) => (
            <div key={comment.id} className="bg-background-100 rounded-xl p-6 border border-background-200/60">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1.5">
                    <h3 className="text-sm font-semibold text-foreground-950">{comment.name}</h3>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}